import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    scroll-behavior: smooth;
    
    @media (prefers-reduced-motion: reduce) {
      scroll-behavior: auto;
    }
  }

  body {
    font-family: ${props => props.theme.typography.fontFamily.body};
    font-size: ${props => props.theme.typography.fontSize.base};
    line-height: ${props => props.theme.typography.lineHeight.normal};
    color: ${props => props.theme.colors.text.primary};
    background-color: ${props => props.theme.colors.white};
    overflow-x: hidden;
    min-height: 100vh;
    position: relative;
    width: 100%;
  }

  /* Responsive typography scaling */
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    html {
      font-size: 14px;
    }
  }

  /* Ensure images are responsive */
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* Remove default button styles */
  button {
    font-family: inherit;
    border: none;
    background: none;
    cursor: pointer;
  }

  /* Remove default link styles */
  a {
    color: inherit;
    text-decoration: none;
  }

  /* Accessibility: Focus visible for keyboard navigation */
  *:focus-visible {
    outline: 2px solid ${props => props.theme.colors.black};
    outline-offset: 2px;
  }

  /* Hide focus outline for mouse users */
  *:focus:not(:focus-visible) {
    outline: none;
  }

  /* Smooth transitions for prefers-reduced-motion */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

  /* Custom scrollbar for webkit browsers */
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.gray[100]};
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.gray[400]};
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.gray[600]};
  }

  /* Firefox scrollbar */
  * {
    scrollbar-width: thin;
    scrollbar-color: ${props => props.theme.colors.gray[400]} ${props => props.theme.colors.gray[100]};
  }

  /* Prevent horizontal scroll globally */
  body, html {
    overflow-x: hidden;
    width: 100%;
  }
  
  /* Single scroll container */
  #root {
    width: 100%;
    min-height: 100vh;
  }

  /* Ensure proper text rendering */
  body {
    text-rendering: optimizeLegibility;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
  }

  /* Improve touch interactions on mobile */
  @media (hover: none) and (pointer: coarse) {
    button, a {
      -webkit-tap-highlight-color: transparent;
    }
  }

  /* Safe area insets for mobile devices (notch support) */
  @supports (padding: max(0px)) {
    body {
      padding-left: max(0px, env(safe-area-inset-left));
      padding-right: max(0px, env(safe-area-inset-right));
    }
  }

  /* Loading skeleton animation */
  @keyframes shimmer {
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 1000px 0;
    }
  }

  /* Fade in animation for lazy-loaded images */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Print styles */
  @media print {
    * {
      background: white !important;
      color: black !important;
    }
  }
`;
